import { useCallback, useEffect, useState } from 'react';

export const useShowTooltip = (ref: React.RefObject<HTMLElement>, label: React.ReactNode): boolean => {
  const [showTooltip, setShowTooltip] = useState(false);

  const compareSize = useCallback(() => {
    if (!ref.current) {
      return;
    }
    const compare = ref.current.scrollWidth > ref.current.clientWidth;
    setShowTooltip(compare);
  }, [ref]);

  // eslint-disable-next-line modernloop/no-use-effect.cjs -- Effect manages an external subscription/listener after render and cleanup.
  useEffect(() => {
    compareSize();
    window.addEventListener('resize', compareSize);

    return () => {
      window.removeEventListener('resize', compareSize);
    };
  }, [compareSize]);

  // If the label changes, we need to re-run the compareSize effect
  // eslint-disable-next-line modernloop/no-use-effect.cjs -- Effect intentionally performs a side effect after render; revisit before adding logic.
  useEffect(() => {
    if (!label) {
      return;
    }
    compareSize();
  }, [label, compareSize]);

  return showTooltip;
};
